export default "__VITE_ASSET__DmOepIqg__"